import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutUsComponent } from './home-components/about-us/about-us.component';
import { ContactUsComponent } from './home-components/contact-us/contact-us.component';
import { LoginComponent } from './home-components/login/login.component';
import { ServicesComponent } from './home-components/services/services.component';
import { SignupComponent } from './home-components/signup/signup.component';
import { ForgotPasswordComponent } from './home-components/forgot-password/forgot-password.component';
import { VerifyEmailComponent } from './home-components/verify-email/verify-email.component';
import { VerifyComponent } from './home-components/verify/verify.component';
import { PasswordChangedComponent } from './home-components/password-changed/password-changed.component';
import { EnterNewPasswordComponent } from './home-components/enter-new-password/enter-new-password.component';
import { ExpiredPasswordLinkComponent } from './home-components/expired-password-link/expired-password-link.component';
import { PageNotFoundComponent } from './home-components/page-not-found/page-not-found.component';
import { ServicesGreenCardComponent } from './home-components/services-green-card/services-green-card.component';
import { AuthService } from '../core/guards/auth.guard';
import { ProfileGuard } from '../core/guards/profile.guard';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'signup',
    component: SignupComponent
  },
  {
    path: 'verify-email',
    component: VerifyEmailComponent
  },
  {
    path: 'verify-success',
  component: VerifyComponent
  },
  {
    path: 'about-us',
    component: AboutUsComponent
  },
  {
    path: 'services',
    component: ServicesComponent
  },
  {
    path: 'services-green-card',
    component: ServicesGreenCardComponent
  },
  {
    path: 'contact-us',
    component: ContactUsComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'new-password',
    component: EnterNewPasswordComponent
  },
  {
    path: 'expired-link',
    component: ExpiredPasswordLinkComponent,
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
